import { render, staticRenderFns } from "./scrollTab.vue?vue&type=template&id=978859e0&scoped=true&"
import script from "./scrollTab.vue?vue&type=script&lang=js&"
export * from "./scrollTab.vue?vue&type=script&lang=js&"
import style0 from "./scrollTab.vue?vue&type=style&index=0&id=978859e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978859e0",
  null
  
)

export default component.exports